import { $tag, TaggedEnumUnion, extendEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { $NumberFamily, NumberFamily } from './number-family';

const $ = 'JtfMode';

export const JtfMode = {
  WholeNumbers: extendEnum($, NumberFamily.WholeNumbers),
  Fractions: extendEnum($, NumberFamily.Fractions),
  Decimals: extendEnum($, NumberFamily.Decimals),
  Integers: extendEnum($, NumberFamily.Integers),
} as const;

export type JtfMode = TaggedEnumUnion<typeof JtfMode>;

const JtfModes = {
  [$tag]: $,
  [JtfMode.WholeNumbers]: {
    ...$NumberFamily.describe(NumberFamily.WholeNumbers),
    value: JtfMode.WholeNumbers,
  },
  [JtfMode.Fractions]: {
    ...$NumberFamily.describe(NumberFamily.Fractions),
    value: JtfMode.Fractions,
  },
  [JtfMode.Decimals]: {
    ...$NumberFamily.describe(NumberFamily.Decimals),
    value: JtfMode.Decimals,
  },
  [JtfMode.Integers]: {
    ...$NumberFamily.describe(NumberFamily.Integers),
    value: JtfMode.Integers,
  },
} as const;

export const $JtfMode = buildStaticContext(JtfModes);
export type $JtfMode = typeof $JtfMode;
